import { ScenicSpotsSection } from '../components';
import React from 'react';

const ScenicSpots = () => {
  return (
    <>
      <ScenicSpotsSection />
    </>
  );
};

export default ScenicSpots;